import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_empty from '@devices/settings/device_settings/app_setting_empty.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import virtual_components from '../../settings/device_settings/virtual_components';
import scripts_gen_2 from '../../settings/device_settings/scripts_gen_2';
import webhooks_gen_2 from '../../settings/device_settings/webhooks_gen_2';
import schedule_gen_2 from '../../settings/device_settings/schedule_gen_2';

export default {
	name: 'ShellyIRCtrl',
	friendly_name: 'IR Controller Gen4',
	family: 'ir_controller',
	isPM: false,
	modes: {
		ir_controller: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				networks_gen_2_plus,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				app_setting_empty,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
